import React from 'react';
import { useAiRovoCurrentRouteConfiguration } from '@jira/ai-rovo_actions-selector/src/useAiRovoCurrentRouteConfiguration.tsx';
import { JiraBottomRightCornerOutlet } from '@atlassian/jira-layout-controller/src/ui/bottom-right-corner/outlet/index.tsx';
import { AiRovoButtonWrapperRefresh } from './AiRovoButtonWrapperRefresh.tsx';
import { useIsRovoAvailableForRoute } from './useIsRovoAvailableForRoute.tsx';

export const GlobalAiRovoButton = () => {
	const isRovoAvailableForRoute = useIsRovoAvailableForRoute();
	const configuration = useAiRovoCurrentRouteConfiguration();

	if (!isRovoAvailableForRoute) {
		return null;
	}

	/*
		This is a hybrid solution that allow us to do eager fetching of the panel modules on button hover,
		without having to props drill the panel placeholder component down the tree.
		https://hello.atlassian.net/wiki/spaces/AM3/pages/5585113512/LDR+Loading+Strategy+for+Rovo+Side+Panel+using+Entrypoints
	*/
	return (
		<JiraBottomRightCornerOutlet orderFromRight={0} id="floating-element-id">
			<AiRovoButtonWrapperRefresh {...configuration} />
		</JiraBottomRightCornerOutlet>
	);
};
